@let isDesktop = device.isDesktopUI();
@let isTablet = device.isTabletUI();

<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start" [class.pl-1]="!isDesktop">
      <ion-button
        class="text-neutral-900"
        [class.menu-toggle-desktop]="isDesktop"
        [attr.aria-label]="'header.toggleMenuAria' | mlTranslate"
        (click)="onMenuToggle()"
      >
        <ml-icon [name]="!isDesktop ? 'menu' : collapsed() ? 'sidebarExpand' : 'sidebarCollapse'" size="sm" />
      </ion-button>
    </ion-buttons>

    @if (!isDesktop) {
      <img slot="start" class="h-9 w-32" src="assets/icon/medlink.svg" alt="Medlink" />
    } @else {
      <div class="header-desktop-search">
        <ml-search />
      </div>
    }

    <ion-buttons slot="end">
      @if (isTablet || isDesktop) {
        <div class="header-tablet-actions">
          <ml-notifications kind="notifications" />
          <ml-notifications kind="messages" />

          <span class="header-tablet-divider" aria-hidden="true"></span>

          <ml-profile-menu />
        </div>
      } @else {
        <div class="flex items-center gap-2">
          <ml-notifications kind="messages" />
          <ml-search />
          <ml-profile-menu />
        </div>
      }
    </ion-buttons>
  </ion-toolbar>

  @if (isTablet) {
    <ion-toolbar class="search-toolbar">
      <div class="header-search-wrap">
        <ml-search />
      </div>
    </ion-toolbar>
  }
</ion-header>
